/** @jsx h */

import { styleguide } from 'styleguide'
import styled, { css } from 'preact-emotion'
import { springY } from './utils'

const active = brand => css`
  background-color: ${brand};
  color: ${styleguide.colors.background};
`

const out = css`
  transform: translate3d(0, -20px, 0);
  opacity: 0;
  pointer-events: none;
`

export default styled('button')`
  background-color: ${styleguide.colors.lightGray};
  color: ${styleguide.colors.widgetGray};
  width: 100%;
  border: 0;
  border-radius: ${styleguide.radii.inner};
  padding: ${styleguide.spacing.s};
  margin-bottom: 10px;
  transition: all 300ms ${styleguide.timingFuncs.ease};
  transition-delay: ${props => (props.out ? `${200 + props.outDelay}ms` : 0)};
  cursor: pointer;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${styleguide.mobile(
    css(`
      font-size: 12px;
    `)
  )};
  text-align: left;
  font-family: inherit;
  position: relative;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    ${props => active(props.theme.brand)};
  }
  &:focus {
    outline: 0;
  }
  ${props => (props.selected ? active(props.theme.brand) : null)};
  ${props => props.out && out};
  ${props => (props.springToY ? springY(props.springToY, 'softest') : null)};
`



// WEBPACK FOOTER //
// ../api/src/Answer.jsx